/**
 * Canonical keys used by the public project-team UI (lowercase TEAM_CATEGORIES).
 * Accepts both legacy BM camelCase values (`engineers`, `landscapers`) and the
 * company-first API labels (`Engineer`, `Landscaping`) from ProjectTeamMemberService.
 */
const CANONICAL_BY_NORMALISED_INPUT: Record<string, string> = {
    // Architect
    architect: 'architects',
    architects: 'architects',
    // Builder
    builder: 'builders',
    builders: 'builders',
    // Interior Designer (space-form API label + camelCase + display key)
    'interior designer': 'interiordesigners',
    interiordesigner: 'interiordesigners',
    interiordesigners: 'interiordesigners',
    // Engineer
    engineer: 'engineers',
    engineers: 'engineers',
    // Landscaping / Landscapers
    landscaping: 'landscapers',
    landscaper: 'landscapers',
    landscapers: 'landscapers',
    // Joinery
    joinery: 'joinery',
    // Fabricator
    fabricator: 'fabricator',
    fabricators: 'fabricator',
};

/**
 * Normalises a persisted ProjectGroup / ProjectTeamMember Category to the
 * canonical key used for matching and ordering on the project detail page.
 */
export const normalizeProjectTeamCategory = (category: string): string => {
    if (!category) return '';

    const trimmed = category.trim();
    if (!trimmed) return '';

    const lower = trimmed.toLowerCase();
    const mapped = CANONICAL_BY_NORMALISED_INPUT[lower];
    if (mapped) {
        return mapped;
    }

    return lower;
};
